import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box, Tab, Tabs } from "@mui/material";
import moment from "moment";

import { fetchAllTransactions } from "../../redux/slice/allTransactions";
import { fetchEarnedPoints } from "../../redux/slice/earnedPoints";

import "./PointHistory.scss";
import EarnedPoints from "./EarnedPoints";
import RedeemedPoints from "./RedeemedPoints";
import ExpiredPoints from "./ExpiredPoints";
import { getFieldsValue, formatIndianNumber } from "../../utils/common";
import Spinner from "../../component/spinner/Spinner";
import gold_rupe_icon_md from "../../assets/images/gold_rupe_md.svg";
import hotel_Icon from "../../assets/images/transctionIcon.svg";
import clockIcon from "../../assets/images/last_minute_deal.svg";
import searchIcon from "../../assets/images/search.svg";
import NoDataComp from "../../component/NoDataComp";
// import Aside from "../../component/aside/Aside";
// import Footer2 from "../../component/footer/Footer2";
// import Header from "../../component/header/Header";

const PointHistory = () => {
  const dispatch = useDispatch();
  const { allTransactionData, loading } = useSelector(
    (state) => state.allTransactions,
  );
  const { earnedPointsData } = useSelector((state) => state.earnedPoints);
  const { redeemedPointsData } = useSelector((state) => state.earnedPoints);
  const { expiredPointsData } = useSelector((state) => state.earnedPoints);
  const { expiringPointsData } = useSelector((state) => state.earnedPoints);

  const [currenttabIndex, setCurrenttabIndex] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [filteredTransaction, setFilteredTransaction] = useState([]);
  const [filteredEarnedPoints, setFilteredEarnedPoints] = useState([]);
  const [filteredRedeemedPoints, setFilteredRedeemedPoints] = useState([]);
  const [filteredExpiredPoints, setFilteredExpiredPoints] = useState([]);
  const [filteredExpiringPoints, setFilteredExpiringPoints] = useState([]);
  const handleChange = (event, newValue) => {
    setCurrenttabIndex(newValue);
    setSearchValue("");
  };
  const handleSubmit = () => {
    if (searchValue) {
      const result = allTransactionData?.transactions.filter((item) => {
        if (
          getFieldsValue(item?.extended_fields?.field, "retailer_name")
            ?.toLowerCase()
            ?.includes(searchValue.toLowerCase())
        ) {
          return item;
        } else {
          return false;
        }
      });

      setFilteredTransaction(result);
    }
  };

  useEffect(() => {
    const startDate = "2024-06-01";
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1); // Add 1 day to the current date
    const endDate = tomorrow.toISOString().split("T")[0];
    dispatch(fetchAllTransactions({ startDate, endDate }));
    dispatch(fetchEarnedPoints());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (currenttabIndex === 0) {
      // Combine all transaction types for "All Transactions" tab
      const combinedTransactions = [];

      // Add regular transactions (earned transactions are already included here)
      if (allTransactionData?.transactions?.length > 0) {
        allTransactionData.transactions.forEach((item) => {
          combinedTransactions.push({
            ...item,
            transactionType: "regular",
            sortDate: new Date(item?.billing_time),
          });
        });
      }

      // Add redeemed points
      if (redeemedPointsData?.length > 0) {
        redeemedPointsData.forEach((item) => {
          combinedTransactions.push({
            ...item,
            transactionType: "redeemed",
            sortDate: new Date(item?.redeemed_time),
          });
        });
      }

      // Add expired points
      if (expiredPointsData?.length > 0) {
        expiredPointsData.forEach((item) => {
          combinedTransactions.push({
            ...item,
            transactionType: "expired",
            sortDate: new Date(item?.expired_on),
          });
        });
      }
      if (expiringPointsData?.length > 0) {
        expiringPointsData.forEach((item) => {
          combinedTransactions.push({
            ...item,
            transactionType: "expiring",
            sortDate: new Date(item?.expiring_on),
          });
        });
      }

      // Sort by date (most recent first)
      combinedTransactions.sort((a, b) => b.sortDate - a.sortDate);

      // Apply search filter if search value exists
      if (searchValue) {
        const result = combinedTransactions.filter((item) => {
          const retailerName =
            getFieldsValue(
              item?.extended_fields?.field,
              "retailer_name",
            )?.toLowerCase() || "";
          const storeName = item?.store?.toLowerCase() || "";
          const notes = item?.notes?.toLowerCase() || "";
          const searchLower = searchValue.toLowerCase();

          return (
            retailerName.includes(searchLower) ||
            storeName.includes(searchLower) ||
            notes.includes(searchLower)
          );
        });
        setFilteredTransaction(result);
      } else {
        setFilteredTransaction(combinedTransactions);
      }
    }

    if (currenttabIndex === 1) {
      setFilteredEarnedPoints(earnedPointsData);
    }

    if (currenttabIndex === 2) {
      setFilteredRedeemedPoints(redeemedPointsData);
    }

    if (currenttabIndex === 3) {
      setFilteredExpiredPoints(expiredPointsData);
      setFilteredExpiringPoints(expiringPointsData);
    }
  }, [
    searchValue,
    allTransactionData,
    currenttabIndex,
    earnedPointsData,
    redeemedPointsData,
    expiredPointsData,
    expiringPointsData,
  ]);

  return (
    <>
      <div>
        <div className="pointHistory">
          <div className="search ">
            <div className="d-flex justify-content-between align-items-center search-div">
              <h1 className="desktop_content">Points History</h1>
              <h1 className="mobile_content recent">Recent Transactions</h1>
              {currenttabIndex === 0 && (
                <div className="rel">
                  <img
                    src={searchIcon}
                    alt="search icon"
                    style={{
                      position: "absolute",
                      left: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                    }}
                  />
                  <input
                    type="text"
                    placeholder="Search in History..."
                    style={{ paddingLeft: "35px" }}
                    onChange={(e) => {
                      setSearchValue(e.target.value);
                    }}
                    value={searchValue}
                  />
                  <button className="radius0_button" onClick={handleSubmit}>
                    Submit
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="tabs">
            {/* <Box sx={{ maxWidth: "80vw" }}> */}
            <Box
              sx={{
                maxWidth: {
                  xs: "100vw", // for extra-small screens (phones)
                  sm: "80vw", // for small screens and up (tablets, etc.)
                },
                top: {
                  xs: `${currenttabIndex === 0 ? "110px" : "70px"}`,
                  sm: `${currenttabIndex === 0 ? "85px" : "70px"}`,
                },
              }}
              className="tabHead"
            >
              <Tabs
                value={currenttabIndex}
                onChange={handleChange}
                scrollButtons="auto"
                aria-label="scrollable auto tabs example"
                allowScrollButtonsMobile
                variant="scrollable"
                scrollButtonsMobile
              >
                <Tab
                  sx={{
                    maxWidth: { xs: "none", sm: "25%" },
                    width: { xs: "auto", sm: "25%" },
                    minWidth: { xs: "120px", sm: "auto" },
                    borderRadius: 2,
                  }}
                  label="All Transactions"
                />
                <Tab
                  sx={{
                    maxWidth: { xs: "none", sm: "25%" },
                    width: { xs: "auto", sm: "25%" },
                    minWidth: { xs: "120px", sm: "auto" },
                  }}
                  label="Earned Points"
                />
                <Tab
                  sx={{
                    maxWidth: { xs: "none", sm: "25%" },
                    width: { xs: "auto", sm: "25%" },
                    minWidth: { xs: "120px", sm: "auto" },
                  }}
                  label="Redeemed Points"
                />
                <Tab
                  sx={{
                    maxWidth: { xs: "none", sm: "25%" },
                    width: { xs: "auto", sm: "25%" },
                    minWidth: { xs: "140px", sm: "auto" },
                  }}
                  label="Expiring/Expired Points"
                />
              </Tabs>
            </Box>
            <div className="tab_content">
              <Box>
                {currenttabIndex === 0 && (
                  <div style={{ height: "100%" }}>
                    <div className="tabTable">
                      <div className="border_bottom_section">
                        {filteredTransaction?.length > 0 ? (
                          filteredTransaction?.map((item, index) => {
                            // Render based on transaction type
                            if (item?.transactionType === "redeemed") {
                              return (
                                <React.Fragment
                                  key={`redeemed-${item?.id || index}`}
                                >
                                  <div className="d-flex justify-content-between transction_list redeem">
                                    <div className="hotel_booking_details d-flex align-items-center">
                                      <div>
                                        <p
                                          style={{
                                            fontSize: "12px",
                                            color: "#ff9800",
                                            fontWeight: "600",
                                            marginBottom: "4px",
                                          }}
                                        >
                                          REDEEMED
                                        </p>
                                        <h1>{item?.notes}</h1>
                                      </div>
                                    </div>
                                    <div className="bookingStatus desktop_content">
                                      <p>
                                        Redeemed on:{" "}
                                        <span className="high_light_text">
                                          {moment(item?.redeemed_time).format(
                                            "Do MMMM",
                                          )}
                                        </span>
                                      </p>
                                    </div>
                                    <div className="points_gold">
                                      <p
                                        className="high_light_text"
                                        style={{ display: "flex" }}
                                      >
                                        -{formatIndianNumber(item?.points_redeemed)}{" "}
                                        <img src={gold_rupe_icon_md} alt="" />
                                      </p>
                                    </div>
                                  </div>
                                </React.Fragment>
                              );
                            } else if (item?.transactionType === "expired") {
                              return (
                                <React.Fragment key={`expired-${index}`}>
                                  <div className="d-flex justify-content-between transction_list expired">
                                    <div className="hotel_booking_details d-flex align-items-center">
                                      <div>
                                        <p
                                          style={{
                                            fontSize: "12px",
                                            color: "#8F0000",
                                            fontWeight: "600",
                                            marginBottom: "4px",
                                          }}
                                        >
                                          EXPIRED
                                        </p>
                                        <h1>Points Expired</h1>
                                        <div className="date_expire">
                                          <img src={clockIcon} alt="" /> Expired
                                          on:{" "}
                                          {item?.expired_on
                                            ? moment(item?.expired_on).format(
                                                "DD MMM YYYY",
                                              )
                                            : "Not Available"}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="points_gold">
                                      <p
                                        className="high_light_text"
                                        style={{
                                          display: "flex",
                                          color: "#8F0000",
                                        }}
                                      >
                                        -{formatIndianNumber(item?.points)} Points
                                        {/* <img src={gold_rupe_icon_md} alt="" /> */}
                                      </p>
                                    </div>
                                  </div>
                                </React.Fragment>
                              );
                            } else if (item?.transactionType === "expiring") {
                              return (
                                <React.Fragment key={`expiring-${index}`}>
                                  <div className="d-flex justify-content-between transction_list expiring">
                                    <div className="hotel_booking_details d-flex align-items-center">
                                      <div>
                                        <p
                                          style={{
                                            fontSize: "12px",
                                            color: "#8F0000",
                                            fontWeight: "600",
                                            marginBottom: "4px",
                                          }}
                                        >
                                          EXPIRING
                                        </p>
                                        <h1>Points Expiring</h1>
                                        <div className="date_expire">
                                          <img src={clockIcon} alt="" />{" "}
                                          Expiring on:{" "}
                                          {item?.expiry_date
                                            ? moment(item?.expiry_date).format(
                                                "DD MMM YYYY",
                                              )
                                            : "Not Available"}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="points_gold">
                                      <p
                                        className="high_light_text"
                                        style={{
                                          display: "flex",
                                          color: "#FFA500",
                                        }}
                                      >
                                        {formatIndianNumber(item?.points)}{" "}
                                        {/* <img src={gold_rupe_icon_md} alt="" /> */}
                                      </p>
                                    </div>
                                  </div>
                                </React.Fragment>
                              );
                            } else {
                              // Regular transaction
                              const isEarned = 
                                item?.points?.issued > 0 &&
                                item?.type !== "RETURN" &&
                                getFieldsValue(
                                  item?.extended_fields?.field,
                                  "booking_status",
                                ) !== "REJECTED";

                              return (
                                <React.Fragment
                                  key={`regular-${item?.id || index}`}
                                >
                                  <div className="d-flex justify-content-between transction_list">
                                    <p className="mobile_content bill">
                                      {item?.billing_time
                                        ? moment(item?.billing_time).format(
                                            "DD MMM YYYY",
                                          )
                                        : "Not Available"}
                                    </p>
                                    <div className="hotel_booking_details d-flex align-items-center">
                                      <div>
                                        {isEarned && (
                                          <p
                                            style={{
                                              fontSize: "12px",
                                              color: "#28a745",
                                              fontWeight: "600",
                                              marginBottom: "4px",
                                            }}
                                          >
                                            EARNED
                                          </p>
                                        )}
                                        {item?.type == "RETURN" && (
                                          <p
                                            style={{
                                              fontSize: "12px",
                                              color: "#8F0000",
                                              fontWeight: "600",
                                              marginBottom: "4px",
                                            }}
                                          >
                                            RETURNED
                                          </p>
                                        )}

                                        <h1>
                                          {getFieldsValue(
                                            item?.extended_fields?.field,
                                            "retailer_name",
                                          ) || item?.store}
                                        </h1>
                                        {getFieldsValue(
                                          item?.extended_fields?.field,
                                          "booking_status",
                                        ) !== "REJECTED" && (
                                          <div className="date_expire">
                                            <img
                                              className=" "
                                              src={clockIcon}
                                              alt=""
                                            />
                                            Points Expires on,{" "}
                                            {item?.points?.expiry_date
                                              ? moment(
                                                  item?.points?.expiry_date,
                                                ).format("DD MMM YYYY")
                                              : "Not Available"}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <div className="bookingStatus desktop_content">
                                      <p>
                                        Uploaded on:{" "}
                                        <span className="high_light_text">
                                          {moment(item?.billing_time).format(
                                            "Do MMMM",
                                          )}
                                        </span>
                                      </p>
                                      {item?.extended_fields?.field?.length >
                                        0 &&
                                        getFieldsValue(
                                          item?.extended_fields?.field,
                                          "booking_status",
                                        ) === "REJECTED" &&
                                        item?.reason && (
                                          <p
                                            style={{
                                              color: "#8F0000",
                                              fontSize: "12px",
                                              marginTop: "4px",
                                              fontWeight: "400",
                                              marginRight: "5px",
                                            }}
                                          >
                                            Reason: {item.reason}
                                          </p>
                                        )}
                                    </div>
                                    <div className="points_gold">
                                      <p className="bookingStatus">
                                        Bill Amount
                                      </p>
                                      <p className="amount">₹ {formatIndianNumber(item?.amount)}</p>
                                      {item?.extended_fields?.field?.length >
                                        0 &&
                                      getFieldsValue(
                                        item?.extended_fields?.field,
                                        "booking_status",
                                      ) === "REJECTED" ? (
                                        <p style={{ color: "#8F0000" }}>
                                          REJECTED
                                        </p>
                                      ) : (
                                        <p
                                          className="high_light_text"
                                          style={{ display: "flex" }}
                                        >
                                          {item?.type == "RETURN" ? "-" : "+"}
                                          {formatIndianNumber(item?.points?.issued)}{" "}
                                          <img src={gold_rupe_icon_md} alt="" />
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </React.Fragment>
                              );
                            }
                          })
                        ) : loading ? null : (
                          <NoDataComp />
                        )}
                      </div>
                    </div>
                    {loading ? (
                      <div className="spinner_table_height">
                        <Spinner color="black" />
                      </div>
                    ) : null}
                  </div>
                )}
                {currenttabIndex === 1 && (
                  <>
                    <div style={{ height: "100%" }}>
                      <EarnedPoints
                        filteredEarnedPoints={filteredEarnedPoints}
                      />
                    </div>
                  </>
                )}
                {currenttabIndex === 2 && (
                  <>
                    <RedeemedPoints
                      filteredRedeemedPoints={filteredRedeemedPoints}
                    />
                  </>
                )}
                {currenttabIndex === 3 && (
                  <>
                    <ExpiredPoints
                      filteredExpiredPoints={filteredExpiredPoints}
                      filteredExpiringPoints={filteredExpiringPoints}
                    />
                  </>
                )}
              </Box>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PointHistory;
